// Temporarily hidden sections — flip to re-enable.
export const SHOW_RENT = false;
export const HIDDEN_PROPERTY_TYPES = ["Commercial"]; // warehouse category

export const isListingVisible = (p) =>
  (SHOW_RENT || p.listing_type !== "rent") &&
  !HIDDEN_PROPERTY_TYPES.includes(p.property_type);
